// Ensure users are directed to the /upgrade page if there payment expires.
import get from "lodash/get";
import moment from "moment";
import { STRIPE } from "../constants";
import {
  calculateFreeTrialDaysLeft,
  isPerformClient,
} from "../utils/user-helpers";

const EnsurePaid = async ({ res, locals, isLoggedIn, api, load }, next) => {
  const { momentTZ } = locals;
  const userToRequest = get(locals, "activeUserToRequest");

  const plan = get(userToRequest, "stripe.plan");
  const trialEnd = momentTZ(get(userToRequest, "stripe.trial_end"));
  const periodEnd = momentTZ(get(userToRequest, "stripe.period_end"));
  const periodEndSubscription = momentTZ(
    get(userToRequest, "subscription.periodEnd")
  );
  const periodEndMembership = momentTZ(
    get(userToRequest, "membership.periodEnd")
  );
  const permissions = get(userToRequest, "permissions", []);

  // Not logged in cannot continue (will be taken to login).
  if (!userToRequest) {
    res.redirect("/logout");
    return;
  }
  if (permissions.includes("coach") && !userToRequest.pushAccountInfo) {
    if (
      userToRequest.coachingBilling &&
      userToRequest.coachingBilling.requestPaymentInfoOnNextLogin
    ) {
      return res.redirect("/coach-billing");
    }

    if (userToRequest.coachingFreeTrial) {
      const daysLeft = calculateFreeTrialDaysLeft(userToRequest);
      if (daysLeft < 1) {
        return res.redirect("/coach-billing");
      }
    }
  }

  if (userToRequest.coach && !userToRequest.coach.inactive) {
    // ensure not expired free trial coach
    await load("coach", { user: userToRequest.coach._id });
    const coach = locals.coach;
    if (coach && coach.coachingFreeTrial) {
      const daysLeft = calculateFreeTrialDaysLeft(coach);
      if (daysLeft < 1) {
        return res.redirect("/upgrade-1");
      }
    }
    return next();
  }

  // PERFORM clients are paid for by their gym.
  if (isPerformClient(userToRequest)) return next();

  if (
    userToRequest.coachingInvite &&
    userToRequest.coachingInvite.coach &&
    moment(userToRequest.coachingInvite.coach.invitedAt).diff(
      moment(),
      "days" < 7
    )
  ) {
    return next();
  }

  // Ensure the user has a valid subscription plan and is not a push account
  if (
    plan == "none" &&
    !permissions.includes("ambassador") &&
    !permissions.includes("admin") &&
    !permissions.includes("coach") &&
    !userToRequest.subscription
  ) {
    res.redirect("/upgrade-1");
  }

  // Check if user can continue.
  if (
    // Always allow admins.
    userToRequest.admin ||
    permissions.includes("admin") ||
    // Always allow ambassadors.
    userToRequest.ambassador ||
    permissions.includes("ambassador") ||
    // Always allow coaches.
    permissions.includes("coach") ||
    // Always allow premium coaches
    permissions.includes("coachCanSubmit") ||
    // Check if they are out of trial mode and within a 7 day grace period.
    (userToRequest.stripe &&
      plan !== STRIPE.PLANS.LAUNCH.trial &&
      plan !== STRIPE.PLANS.V2.trial &&
      periodEnd.add(7, "days") > momentTZ()) ||
    // Check if they have any trial time remaining.
    (userToRequest.stripe && trialEnd > momentTZ()) ||
    periodEndSubscription.isAfter(momentTZ()) ||
    periodEndMembership.isAfter(momentTZ())
  ) {
    return next();
  }

  res.redirect("/upgrade-1");
};

export default EnsurePaid;
